<form [formGroup]="onlineBookingUrlForm" class="dialog-root">
  @if (this.onlineBookingUrlDto) {
    <h2 mat-dialog-title>{{"location.label.edit_link" | transloco}}</h2>
  } @else {
    <h2 mat-dialog-title>{{"location.label.add_link" | transloco}}</h2>
  }


  <mat-dialog-content class="column">
    <div class="column" formArrayName="name">
      @for (localizedText of name.controls; let i = $index; track i) {
        <mat-form-field hideRequiredMarker="true" [formGroupName]="i">
          <mat-label>{{ "form.label.label" | transloco }} {{ localizedText.value.language | language }}</mat-label>
          <input formControlName="value" matInput type="text" />
        </mat-form-field>
      }
    </div>

    <mat-form-field hideRequiredMarker="true">
      <mat-label>{{ "form.label.url" | transloco }}</mat-label>
      <input formControlName="link" matInput type="text" />
      <mat-error>{{"error.validation.url" | transloco}}</mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button (click)="close()" mat-button type="button">{{ "button.cancel" | transloco }}</button>

    @if (this.onlineBookingUrlDto) {
      <button mat-flat-button (click)="manage()">{{ "button.save" | transloco }}</button>
    } @else {
      <button mat-flat-button (click)="manage()">Link {{ "location.label.add_link" }}</button>
    }
  </mat-dialog-actions>
</form>
